import React from 'react'

function oldSchoolCopy(text: string) {
  const tempTextArea = document.createElement('textarea')
  tempTextArea.value = text
  document.body.appendChild(tempTextArea)
  tempTextArea.select()
  document.execCommand('copy')
  document.body.removeChild(tempTextArea)
}

export function useCopyToClipboard() {
  const [state, setState] = React.useState<string | null>(null)

  const copyToClipboard = React.useCallback((value: string) => {
    const handleCopy = async () => {
      try {
        if (navigator?.clipboard?.writeText) {
          await navigator.clipboard.writeText(value)
          setState(value)
        } else {
          throw new Error('writeText not supported')
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (_: unknown) {
        oldSchoolCopy(value)
        setState(value)
      }
    }

    void handleCopy()
  }, [])

  return { state, copyToClipboard }
}
